import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {SearchParams, UserSearch} from '@models/search';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {OnboardingService} from '@services/onboarding.service';
import {UserService} from '@services/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-pub-save',
    templateUrl: './pub-save.component.html',
    styleUrls: ['./pub-save.component.scss']
})
export class PubSaveComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    userSearchs: UserSearch[] = [];
    searchParams: SearchParams;
    loading = false;

    constructor(
        private adService: AdService,
        private authenticationService: AuthenticationService,
        private onboardingService: OnboardingService,
        private userService: UserService,
        public dialogRef: MatDialogRef<PubSaveComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.searchParams = this.data.searchParams;
        this.userSearchs = this.data.userSearchs;

        let title = "Ma recherche"
        if (this.searchParams.estate_type.length == 1) {
            title = this.searchParams.estate_type[0];
        }
        if (this.searchParams.cities.length > 0) {
            title += " " + this.searchParams.cities[0].name
        }
        this.favoriteForm = new UntypedFormGroup({
            title: new UntypedFormControl(title),
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.favoriteForm.get('title').value) {
            this.loading = true
            const newUserSearch: UserSearch = {
                id: null,
                title: this.favoriteForm.get('title').value,
                search_ad_params: this.searchParams,
                frequency_alert: '0',
                price_alert: false,
            };

            this.adService.addUserSearch(newUserSearch).subscribe((us) => {
                this.userSearchs.push(us);
                this.dialogRef.close({userSearchs: this.userSearchs, currentSearch: us});
                if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.show_list_search == false) {
                    this.onboardingService.showSearchSaveList();
                }
            }, error => {
                console.log('Error');
                console.log(error);
                this.loading = false
            });
        }
    }
}
